// @flow
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import CapacitorRipple from '../capacitor/Ripple';
import React from 'react';
import type { ChildrenArray, Element } from 'react';
import styles from './ContextMenu.css';
import { Link } from 'react-router';
import classnames from 'classnames';

type OwnProps = {
  'onClick'?: (event: SyntheticEvent<HTMLButtonElement>) => void,
  'children'?: ChildrenArray<Element<any>>,
  'data-test'?: string,
  'keepOpenAfterClick'?: boolean,
  'to'?: string,
  'disabled'?: boolean,
};

const ContextMenuItem = ({
  children,
  onClick,
  to,
  keepOpenAfterClick,
  'data-test': dataTest,
  disabled,
}: OwnProps) => {
  const handleSelect = (event: SyntheticEvent<HTMLButtonElement>) => {
    if (keepOpenAfterClick) {
      event.preventDefault();
    }
    if (onClick) {
      onClick(event);
    }
  };

  const Wrapper = to ? Link : 'div';

  return (
    <DropdownMenu.Item
      data-test={dataTest}
      onSelect={handleSelect}
      className={classnames(styles.contextMenuButton, {
        [styles.isDisabled]: disabled,
      })}
      disabled={disabled}
    >
      <Wrapper
        to={to}
        className={classnames(styles.children, {
          'c-link--expand-hitbox': to,
        })}
      >
        <CapacitorRipple />
        {children}
      </Wrapper>
    </DropdownMenu.Item>
  );
};

export default ContextMenuItem;
